import React from 'react';
import { Button, PriceString } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { HtmlWithLinks } from './HtmlWithLinks/HtmlWithLinks';
import * as S from './styled';
export const Campaign = ({ title, description, bonusSummary, incentives, campaignIncentives, onDismiss, }) => {
    const bonusProgressPercentage = (bonusSummary.totalReceived.value * 100) / bonusSummary.totalAvailable.value;
    // Check if campaign only has DOUBLE_SIGNUP_REFERRAL_BONUS incentive
    const hasOnlyDoubleReferralBonus = campaignIncentives.length === 1 && campaignIncentives[0].type === 'DOUBLE_SIGNUP_REFERRAL_BONUS';
    // For DOUBLE_SIGNUP_REFERRAL_BONUS campaigns, use the incentive's isCompleted status
    const isCompleted = bonusProgressPercentage === 100;
    const showProgressBar = !hasOnlyDoubleReferralBonus;
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, { "$noProgressBar": !showProgressBar },
            React.createElement(S.Headings, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Description, null,
                    React.createElement(HtmlWithLinks, { html: description })),
                !hasOnlyDoubleReferralBonus && isCompleted && (React.createElement(S.Buttons, null,
                    React.createElement(Button, { label: "Order samples", appearance: "primary", size: "xsmall", to: routing.settings.samples.order, analytics: "campaignOrderSamples" }),
                    React.createElement(Button, { label: "Hide recommendation", appearance: "secondary", size: "xsmall", analytics: "campaignHideRecommendation", onClick: onDismiss })))),
            showProgressBar && (React.createElement(CircleProgress, { progress: bonusProgressPercentage, earnedBonus: bonusSummary.totalReceived.value }))),
        incentives));
};
const CircleProgress = ({ progress, earnedBonus }) => {
    return (
    // @ts-ignore
    React.createElement(S.CircleProgress, { style: { '--progress': `${progress}%` } },
        React.createElement(S.CircleProgressText, null,
            React.createElement(PriceString, { value: earnedBonus }))));
};
